import { Controller } from "@hotwired/stimulus"
import axios from "axios"

// Drag&drop kolejności powiązanych kont usera na /profile/accounts oraz zapis limitu
// pozycji w menu kont. Po upuszczeniu zbieramy data-id z aktualnej kolejności DOM-u
// i zapisujemy pełną listę id przez POST /profile/accounts/order. Zmiana pola limitu
// zapisuje wartość przez POST /profile/accounts/menu_limit.
//
// Wymagane data-attributes na elemencie z controllerem:
//   data-controller="accounts-reorder"
//   data-accounts-reorder-order-url-value="<%= profile_accounts_order_path %>"
//   data-accounts-reorder-limit-url-value="<%= profile_accounts_menu_limit_path %>"
export default class extends Controller {
  static targets = ["item", "limit"]
  static values = { orderUrl: String, limitUrl: String }

  dragstart(event) {
    const item = event.target.closest("[data-accounts-reorder-target='item']")
    if (!item) {
      event.preventDefault()
      return
    }
    this.draggedItem = item
    event.dataTransfer.effectAllowed = "move"
    item.classList.add("opacity-40")
  }

  dragover(event) {
    if (!this.draggedItem) return
    event.preventDefault()

    const target = event.target.closest("[data-accounts-reorder-target='item']")
    if (!target || target === this.draggedItem) return

    const rect = target.getBoundingClientRect()
    const insertBefore = event.clientY < rect.top + rect.height / 2
    if (insertBefore) {
      target.parentNode.insertBefore(this.draggedItem, target)
    } else {
      target.parentNode.insertBefore(this.draggedItem, target.nextSibling)
    }
  }

  drop(event) {
    event.preventDefault()
  }

  dragend() {
    if (!this.draggedItem) return
    this.draggedItem.classList.remove("opacity-40")
    this.draggedItem = null
    this.saveOrder()
  }

  saveOrder() {
    const order = this.itemTargets.map((el) => el.dataset.id)

    axios.post(this.orderUrlValue, { order }, {
      headers: { Accept: "application/json" }
    }).catch((error) => {
      console.error("accounts reorder save failed", error)
    })
  }

  // Zapis limitu przy zmianie pola (blur/enter).
  saveLimit() {
    if (!this.hasLimitTarget) return

    axios.post(this.limitUrlValue, { limit: this.limitTarget.value }, {
      headers: { Accept: "application/json" }
    }).catch((error) => {
      console.error("accounts menu limit save failed", error)
    })
  }
}
